/*
 * @Author: Json Chen
 * @Date: 2021-06-30 15:43:21
 * @LastEditTime: 2021-07-01 18:09:20
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/ModalDelHOC/index.tsx
 */
/*
 * @Author: Json Chen
 * @Date: 2021-06-30 15:24:58
 * @LastEditTime: 2021-06-30 15:24:58
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/components/ModalTips/index.tsx
 */

import React from 'react';
import { Modal } from 'antd';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

/*
  modalDataStrategy  Example :  {
    confirm: {
      title: 'title',
      content: 'content',
      buttonType: 'primary',
      okText: 'Confirm',
    },
    delete: {
      title: 'title',
      content: 'content',
      buttonType: 'danger',
      okText: 'Delete',
    },
  };

*/

const DEFAULTMODALDATA: any = {
  title: 'Title',
  content: 'Content',
  buttonType: 'primary',
  okText: 'Confirm',
};

const ModalDelHOC = (Comp, { modalDataStrategy, canDel }) => {
  const WrapperComp = (props) => {
    const i18n = useI18n();
    const getI18n = (str) => i18nGet(i18n, str);
    const _modalDataStrategy =
      typeof modalDataStrategy === 'function'
        ? modalDataStrategy({ getI18n })
        : modalDataStrategy;
    const { value, onChange } = props;

    const [visible, setVisible] = React.useState<boolean>(false);
    const [delIndex, setDelIndex] = React.useState<number>(-1);

    const [modalData, setModalData] = React.useState(DEFAULTMODALDATA);

    const onOk = () => {
      if (delIndex !== -1) {
        onChange(
          value.filter((item, index) => index !== delIndex),
          'DEL',
        );
      }
      onCancel();
    };

    const onDelClick = (index: number) => {
      // canDel 判断列表项是否可以被删除
      if (canDel({ list: value, index })) {
        setModalData(_modalDataStrategy.delete);
        setDelIndex(index);
      } else {
        setModalData(_modalDataStrategy.confirm);
      }
      setVisible(true);
    };

    const onCancel = () => {
      setVisible(false);
      setDelIndex(-1);
      setModalData(DEFAULTMODALDATA);
    };

    const cancelButtonProps: any = {};

    if (modalData.buttonType === 'primary') {
      cancelButtonProps.style = {
        display: 'none',
      };
    }
    return (
      <React.Fragment>
        <Comp {...props} onDelClick={onDelClick} />
        <Modal
          title={modalData.title}
          visible={visible}
          okButtonProps={{
            type: modalData.buttonType,
          }}
          okText={modalData.okText || getI18n('general.confirm')}
          cancelButtonProps={cancelButtonProps}
          cancelText={getI18n('general.cancel')}
          width={600}
          maskClosable={false}
          onOk={onOk}
          onCancel={onCancel}>
          <div>{modalData.content}</div>
        </Modal>
      </React.Fragment>
    );
  };
  return WrapperComp;
};

export default ModalDelHOC;
